module.exports = __webpack_public_path__ + "img/t-shirts_tanks.3325209e.svg";